import { render, staticRenderFns } from "./ShippingCompany.vue?vue&type=template&id=f5e15582&scoped=true"
import script from "./ShippingCompany.vue?vue&type=script&lang=js"
export * from "./ShippingCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e15582",
  null
  
)

export default component.exports